import React from 'react';
import { useTheme, type ThemePreference } from '../../hooks/useTheme';
import './ThemeToggle.css';

const SunIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2.5M12 19.5V22M4.93 4.93l1.77 1.77M17.3 17.3l1.77 1.77M2 12h2.5M19.5 12H22M4.93 19.07l1.77-1.77M17.3 6.7l1.77-1.77" />
  </svg>
);

const MoonIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden>
    <path d="M21 13.2A9 9 0 1 1 10.8 3 7 7 0 0 0 21 13.2Z" />
  </svg>
);

const OPTIONS: { value: ThemePreference; label: string; icon: React.ReactNode }[] = [
  { value: 'dark', label: 'Dark', icon: <MoonIcon /> },
  { value: 'light', label: 'Light', icon: <SunIcon /> },
];

interface ThemeToggleProps {
  labeled?: boolean;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ labeled = false }) => {
  const { preference, setTheme } = useTheme();

  return (
    <div
      className={`theme-toggle${labeled ? ' theme-toggle--labeled' : ''}`}
      role="group"
      aria-label="Theme"
    >
      {OPTIONS.map((option) => (
        <button
          key={option.value}
          type="button"
          className={`theme-toggle__btn${preference === option.value ? ' theme-toggle__btn--active' : ''}`}
          aria-pressed={preference === option.value}
          aria-label={`${option.label} theme`}
          title={option.label}
          onClick={() => setTheme(option.value)}
        >
          {option.icon}
          {labeled && <span>{option.label}</span>}
        </button>
      ))}
    </div>
  );
};

export default ThemeToggle;
